var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagentaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    viewBox: "0 0 61 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69678 0.0300619H11.8102L11.5974 8.3571C20.3463 8.90544 23.1997 10.303 30.2171 15.5438C35.8563 11.3706 41.8339 8.40563 49.0303 8.36195L49.0206 -0.00390625L51.1728 0.0252093L51.0325 7.82817C50.989 10.1671 50.7182 10.0167 48.4403 10.3224C40.2621 11.4239 37.1185 12.4721 30.3429 18.2467C23.6495 13.1951 20.0126 10.8902 12.1584 10.3612C9.66292 10.1914 9.37758 10.0652 9.55169 8.00286L9.69194 0.0252093L9.69678 0.0300619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91357 4.70312H7.02703L7.10441 9.09957C7.32205 13.4281 11.0025 12.5837 13.7446 13.001C21.8889 14.2433 24.7617 16.7764 30.5798 22.2161C36.1463 15.1216 42.8494 13.2194 51.4338 12.6323C52.6526 12.5498 53.6488 10.8465 53.6682 9.71585L53.7649 4.76136L55.9171 4.79047L55.6946 9.6285C55.5737 12.2101 53.7262 14.6946 51.0373 14.8547C41.0842 15.4613 36.2672 18.2758 30.5169 25.545C24.9165 19.1007 20.912 15.6457 11.9891 14.9615C8.39087 14.9566 5.20375 13.86 5.07317 9.71585L4.91357 4.70312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.32841L2.47134 9.29929C2.76636 13.2105 5.09261 17.1071 9.74996 17.3886C18.4311 17.9126 25.8596 21.0862 29.5691 29.5297L30.2945 31.1747H30.7298C31.0683 30.0392 31.3295 29.4909 31.8711 28.4379C36.3302 21.1978 41.9016 17.7865 50.4763 17.5438C55.3126 16.9906 57.8807 14.3799 58.3885 9.23621L60.8163 9.2168C60.2505 14.3994 56.8506 19.4363 51.342 19.9653C49.0738 20.1788 47.3956 20.1254 45.0742 20.7271C39.9332 22.0664 35.8369 25.2934 33.264 30.6167C32.0356 33.3778 31.5423 35.2946 31.5036 38.3226L29.3224 38.2886C29.1096 35.1393 28.7469 32.1356 26.943 29.4327C21.7391 21.6443 18.2618 20.6252 9.50331 19.7226C3.24999 19.0773 0.836678 14.7245 0.00967258 9.32355L0 9.32841Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4442 6.71289C33.1477 6.71289 35.7351 7.22726 38.1049 8.16381L34.6566 9.70208L34.6421 9.75546C33.2928 9.44004 31.8854 9.2702 30.4394 9.2702C29.0756 9.2702 27.7456 9.42063 26.4688 9.70208L22.9093 8.11044C25.2452 7.20785 27.7843 6.71289 30.4394 6.71289H30.4442ZM50.7131 22.3285C51.1726 24.0609 51.4192 25.8806 51.4192 27.7634C51.4192 39.3854 42.0271 48.8091 30.4442 48.8091C18.8613 48.8091 9.46924 39.3854 9.46924 27.7634C9.46924 25.8806 9.71589 24.056 10.1802 22.3188L12.8014 22.4256C12.2936 24.1143 12.0228 25.9049 12.0228 27.7586C12.0228 37.9684 20.2735 46.2469 30.4491 46.2469C40.6246 46.2469 48.8753 37.9684 48.8753 27.7586C48.8753 25.9049 48.6045 24.1191 48.0967 22.4353L50.7179 22.3285H50.7131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2839 24.3457C43.2512 25.1706 43.8654 26.4032 43.8654 27.7765C43.8654 30.261 41.8583 32.2797 39.3773 32.2797C38.0135 32.2797 36.7899 31.6683 35.9629 30.6977L37.3993 28.8343C37.7765 29.538 38.5213 30.0184 39.3725 30.0184C40.6106 30.0184 41.6117 29.0139 41.6117 27.7716C41.6117 26.9127 41.1329 26.1703 40.4268 25.7918L42.2791 24.3457H42.2839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.62 24.3457C17.6528 25.1706 17.0386 26.4032 17.0386 27.7765C17.0386 30.261 19.0456 32.2797 21.5266 32.2797C22.8953 32.2797 24.1141 31.6683 24.9411 30.6977L23.5047 28.8343C23.1275 29.538 22.3827 30.0184 21.5315 30.0184C20.2934 30.0184 19.2923 29.0139 19.2923 27.7716C19.2923 26.9127 19.7711 26.1703 20.4772 25.7918L18.6249 24.3457H18.62Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 66.6158,
    y1: 23.7697,
    x2: -8.96241,
    y2: 23.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912799,
    stopColor: "#FB00A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.8163,
    height: 48.8032,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagentaLogo);
export default __webpack_public_path__ + "static/media/magentaLogo.793b139a0d1b3b868517b19a7d4aa49e.svg";
export { ForwardRef as ReactComponent };